import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { CALCULATOR_LIST } from "../content/calculators";
import { useSeo } from "../lib/seo";

export default function CalculatorsHub() {
  useSeo({
    title: "Profit Calculators for Indian Sellers | ProfitMigo",
    description: "Browse free ProfitMigo calculators: product profit, Meesho profit, Amazon seller profit, COD/RTO profit and marketplace fee calculators for Indian sellers.",
    path: "/calculators",
  });

  return (
    <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Calculators" }]} />
      <header className="max-w-3xl">
        <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Calculators</h1>
        <p className="mt-4 text-lg text-muted-foreground">
          Free, instant tools to understand your real profit, pricing and marketplace fees. No sign-up required.
        </p>
      </header>

      <div className="mt-10">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">E-commerce profitability</h2>
        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CALCULATOR_LIST.map((c) => (
            <Link
              key={c.slug}
              to={c.path}
              data-testid={`hub-calc-${c.slug}`}
              className="group flex flex-col justify-between rounded-xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-sm"
            >
              <div>
                <h3 className="font-display text-xl font-semibold">{c.name}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{c.valueProp}</p>
              </div>
              <span className="mt-6 inline-flex items-center text-sm font-medium text-primary">
                Open calculator <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
